import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { getEffectiveShipmentSummary } from "../../utils/effective-shipment-summary";

const catalogEntry = fgColumnEntries["electronic-com-invoice"];

function getElectronicCommercialInvoice(row: FulfillmentGroupData): string {
  const summary = getEffectiveShipmentSummary(row);
  const invoiceShipment = summary?.carrierShipments.find(
    (cs) => cs.commercialInvoiceUrl,
  );
  if (!invoiceShipment) {
    return "N/A";
  }

  return invoiceShipment.comInvoiceSubmittedElectronically ? "true" : "false";
}

export const CommercialInvoiceSubmittedElectronicallyColumn: Column2<FulfillmentGroupData> =
  {
    key: catalogEntry.key,
    title: catalogEntry.title,
    alignment: ColumnAlignment.LEFT,
    renderNormalCell: ({ row }) => {
      return <RedoTableTextCell text={getElectronicCommercialInvoice(row)} />;
    },
    width: catalogEntry.defaultWidth,
    hidden: true,
  };
